<template>
  <div class="home">
    <h1>Home</h1>
    <p>My first Vue.js app!</p>
  </div>
</template>